import {
  doc,
  serverTimestamp,
  setDoc,
  collection,
  getDoc,
  getDocs,
  query,
  orderBy,
  deleteDoc,
} from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { db, storage } from "../../firebase";

const collection_name = "properties";

export default class PropertiesAPI {
  // Add / Update Property
  async setProperty(data, updateTime = true) {
    const payloadData = updateTime ? { updatedAt: serverTimestamp() } : {};
    try {
      await setDoc(
        doc(db, collection_name, data.id),
        { ...data.payload, ...payloadData },
        { merge: true }
      );
      return { success: true };
    } catch (ex) {
      console.log("PropertiesAPI setProperty error:", ex);
      return { success: false, message: ex };
    }
  }

  // Fetch all properties (ordered by 'order' ascending)
  async getProperties() {
    try {
      const q = query(
        collection(db, collection_name),
        orderBy("order", "asc")
      );
      const querySnapshot = await getDocs(q);
      let propertiesArr = [];
      querySnapshot.forEach((docSnap) => {
        propertiesArr.push({ id: docSnap.id, ...docSnap.data() });
      });
      return { success: true, data: propertiesArr };
    } catch (ex) {
      // Fallback query if 'order' index/field causes issue
      try {
        const fallbackQ = query(
          collection(db, collection_name),
          orderBy("createdAt", "desc")
        );
        const querySnapshot = await getDocs(fallbackQ);
        let propertiesArr = [];
        querySnapshot.forEach((docSnap) => {
          propertiesArr.push({ id: docSnap.id, ...docSnap.data() });
        });
        return { success: true, data: propertiesArr };
      } catch (fallbackEx) {
        console.log("PropertiesAPI getProperties error:", fallbackEx);
        return { success: false, message: fallbackEx };
      }
    }
  }

  // Fetch property by id
  async getPropertyById(propertyId) {
    try {
      const docRef = doc(db, collection_name, propertyId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { success: true, data: docSnap.data() };
      } else {
        return { success: false, message: "No Property Found" };
      }
    } catch (ex) {
      console.log("PropertiesAPI getPropertyById error:", ex);
      return { success: false, message: ex };
    }
  }

  // Delete property image from Firebase Storage
  async deletePropertyImage(imageName) {
    if (!imageName) return { success: true };
    try {
      const fileRef = ref(storage, `images/properties/${imageName}`);
      await deleteObject(fileRef);
      return { success: true };
    } catch (ex) {
      console.log("Storage delete property image warning:", ex?.message || ex);
      return { success: false, message: ex };
    }
  }

  // Delete property document and its storage image
  async deleteProperty(propertyId, imageName = null) {
    try {
      await deleteDoc(doc(db, collection_name, propertyId));
      if (imageName) {
        await this.deletePropertyImage(imageName);
      }
      return { success: true };
    } catch (ex) {
      console.log("PropertiesAPI deleteProperty error:", ex);
      return { success: false, message: ex };
    }
  }

  // Get Shop By Properties section settings (e.g. enable/disable on homepage)
  async getSectionSettings() {
    try {
      const docRef = doc(db, "storeSettings", "properties");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { success: true, data: docSnap.data() };
      } else {
        return { success: true, data: { isEnabled: true } };
      }
    } catch (ex) {
      console.log("PropertiesAPI getSectionSettings error:", ex);
      return { success: false, message: ex };
    }
  }

  // Set Shop By Properties section settings (enable/disable on homepage)
  async setSectionSettings({ isEnabled }) {
    try {
      await setDoc(
        doc(db, "storeSettings", "properties"),
        { isEnabled: Boolean(isEnabled), updatedAt: serverTimestamp() },
        { merge: true }
      );
      return { success: true };
    } catch (ex) {
      console.log("PropertiesAPI setSectionSettings error:", ex);
      return { success: false, message: ex };
    }
  }
}

